import React from 'react'
import Select from 'react-select'
import { NumericFormat } from 'react-number-format';

const ModalPagoFinal = ({ titulo, medios, onChange, value, onChangeImporte, valorAnterior }) => {

	return (
		<>
			<div className="ModalPago">
				{value && value.map((item, i) => {
					return (
						<div className='row' key={item.idRef} style={{ marginTop: 20 }}>
							<div className='col-md-4'>
								<Select
									placeholder={'Medio de pagos'}
									options={medios}
									onChange={(e) => {
										onChange("medioPago", e.value, i);
										onChange("medioPagoNombre", e.label, i);
										onChange("tarifa", e.tarifa, i);
										onChange("id", e.id, i);
										onChange("selectMedios", e, i)
									}}
									onBlur={(e) => {
										onChangeImporte(item.importe);
									}}
									onFocus={(e) => {
										valorAnterior(item.importe);
									}}
									required
									styles={{ color: 'red' }}
								/>
							</div>
							<div className='col-md-3'>
								<input
									type={'text'}
									className="form-control"
									required
									placeholder={'Referencia de Pago'}
									onChange={(e) => onChange("referencia", e.target.value, i)}
								/>
							</div>
							<div className='col-md-3'>
								<NumericFormat
									className="form-control"
									value={0}
									thousandSeparator={true}
									prefix={'$'}
									placeholder={'Importe'}
									disabled={!item?.medioPago}
									onValueChange={(values, sourceInfo) => {
										onChange("importe", values.floatValue, i)
									}}
									onBlur={(e) => {
										onChangeImporte(item.importe);
									}}
									onFocus={(e) => {
										valorAnterior(item.importe);
									}}
								/>
							</div>
							<div className='col-md-1'>
								<button className='btn btn-primary boton_estandar btn-block' style={{ width: 50, paddingTop: 0, marginTop: -5 }} onClick={() => onChange("medioPago", item, i, item.valorImpuestos, true)}>
									<i className="fa-solid fa-xmark"></i>
								</button>
							</div>

						</div>
					)
				})}
			</div>
		</>
	)
}

export default ModalPagoFinal